export default __webpack_public_path__ + "static/media/flag-norway.00fb44e6.svg";